export class UpdateOrderServiceMessage {
  completed: boolean
  price: number

  constructor(completed: boolean, price: number) {
    this.completed = completed
    this.price = price
  }
}
